import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class DatAIDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  <h1 style={{fontSize: '30px'}}>Best IT Training Institute in Chennai</h1>
				  
				  <p><i>Do you have what IT takes?</i> Do you have a peck for information and software, coding and systems? Are you a problem solver? Then Information Technology is just the career for you. At MIET, we help you understand the complex understandings of Data Science and Artificial intelligence through simplified concepts that help you become the leaders of tomorrow 
                    </p><br/>
                    <h5 className="mb-0 mt-2">Data Science and Analytics</h5><br/>
                    <p>Data Science is an interdisciplinary field that involves designing and constructing new processes to model and produce data using algorithms, prototypes, predictive models and custom analysis. As a data scientist, one can estimate the unknown with the help of algorithms and statistical models. Data scientists arrange undefined sets of data using multiple tools and automated systems.</p>
                    <p>Data Analysis, as the name suggests, is analysing large data sets to identify trends, develop charts and create visual representations to help in strategic decision making. Data Analysis is often used to answer tangible industry needs. </p>
                    </ScrollAnimation>	

               
                  <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
                        <p>At MIET, we offer the following courses in Data Science:</p>						
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Data Science Foundations:</b> This course helps you understand the basic concepts involved in Data Science. It will allow you to translate a business problem into a valid research question to find a practical solution.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Data Science with Python:</b> To converge the diverse needs of data science, it is practical to use a programming language such as Python, which has numerous libraries and built-in features to tackle the multidisciplinary approach in Data science and analytics.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Tools and Techniques of Data Science:</b> This course covers the procedures (techniques) and equipment (tools) that help in the collection, storing, manipulating, analysing, visualising, and modelling of data sets. Some of the tools and techniques covered under the subject are Advance Statistics, Data Mining, Predictive Modelling, Time Series Forecasting, Machine Learning and Optimization Techniques.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Domain Exposure:</b> Domain Exposure allows the application of principles of data science and analytics to solve real-life problems in varied domains such as marketing and retail, web and social media, finance and risk, or supply chain and logistics.
								</li>
                                {/* <b>Not just theory, we help you gain practical skills too!</b> */}
							</ul>
                            
						</blockquote>
					</div>
					</ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
				  
                    <h5 className="mb-0 mt-2">Artificial Intelligence (AI)</h5><br/>
                    <p>Artificial Intelligence or AI is the simulation of human intelligence in machines that are enhanced to learn, reason and perceive like humans. Used in various industries from finance to healthcare, AI machines can be built to carry out simple as well as complex tasks. AI is a combination of experience, knowledge in Data Science, and correct tools and technologies. </p>
                    <p>This program caters to working professionals from a variety of industries such as IT professionals, Software developers, Data analysts, Analytics managers, Business analysts, Data engineers, Data scientists, and Beginners or recent graduates.</p>
                    </ScrollAnimation>	

                    <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
                        <p>At MIET, we offer the following courses in Artificial Intelligence: </p>						
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Introduction to Artificial Intelligence:</b> The beginner course helps you understand the basics of AI and its use and application in different industries.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Essential Statistics:</b> A large segment of AI is based on assigning a probability through the collection, classification and analysis of data, where statistics come in handy.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Python for Data Science:</b> AI has the power to power to power some aspects of data science. This course helps understand Python scripts and act on data analysis using a Jupyter-based lab environment.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Data Science with Python:</b> This course gives in-depth knowledge in data analytics, machine learning, data visualization, web scraping, and natural language processing.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Machine Learning (ML):</b> A field of study that allows computers to learn without being explicitly programmed for it. One application of ML can be automated data analysis.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Deep Learning with TensorFlow and Keras:</b> An advanced course that uses concepts and understanding of Machine Learning to unlock the power of data, using TensorFlow and Keras.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Advanced Deep Learning and Computer Vision:</b> An advanced course that uses an understanding of Deep Learning, this covers the real applications of computer vision, and generative-adversarial networks (GANs).
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Natural Language Processing and Speech Recognition:</b> This course covers the science of applying ML algorithms to achieve the text equivalent of any continuous audio speech by processing large amounts of natural language data.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Reinforcement Learning:</b> This course covers Machine Learning technique that allows learning in an interactive environment using feedback of own actions or experiences in a trial and error method.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>AI and Machine Learning Capstone Project:</b> The Capstone Project will allow the implementation of all learned skills and concepts to solve real-world problems across various domains.
								</li>
                                {/* <b>Not just theory, we help you gain practical skills too!</b> */}
							</ul>
                            
						</blockquote>
					</div>
					</ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
                        <h5 className="mb-0 mt-2">How does MIET help you stay on top of IT?</h5><br/>
                        <p>With the growing field, IT has attracted more aspirants and seats. At MIET, we help you become the leader of tomorrow with</p>
                        <ul>
                            <li>Continuous Industry Updates and technology advancements</li>
                            <li>LIVE Projects at par with industry usages</li>
                            <li>Comprehensive study material</li>
                            <li>Experienced faculties</li>
                            <li>Modern and well-equipped infrastructure</li>
                            <li>Constructive peer and faculty reviews</li>
                        </ul>
                    </ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Application Form:</h5><br/>
						<Link to="/online-payment"><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></Link>
					</blockquote>
					</div>
					</ScrollAnimation>
                  </div>
		      </div>
			  <Sidebar courseRestriction="Data Science & AI"/>
		    </div>
		  </div>
		</div>

        }
}

export default DatAIDetails